import React from "react";
import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  Selection
} from "devextreme-react/data-grid";
import OutsideClickHandler from "react-outside-click-handler";
import CachedIcon from "@material-ui/icons/Cached";
import { withStyles } from "@material-ui/core/styles";
import { columns } from "./utils";
import SquareButton from "../../../../../../ui/SquareButton";
import SearchField from "../../../../../../ui/SearchField";
import OrgRequestActions from "../OrgRequestActions";
import Box from "../../../../../../ui/Box";
import OrgRequestDrawer from "../OrgRequestDrawer";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
    "& > div": {
      display: "flex",
      alignItems: "flex-end",
      "& > *:not(:nth-last-child(1))": {
        marginRight: "14px"
      }
    }
  }
};

class OrgRequestTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedRequests: [],
      focusedRequest: -1,
      focusedRowIndex: -1
    };

    this.selectRequests = this.selectRequests.bind(this);
    this.exportSelectedRequests = this.exportSelectedRequests.bind(this);
    this.searchByText = this.searchByText.bind(this);
    this.triggerColumnChooser = this.triggerColumnChooser.bind(this);
    this.onRowClick = this.onRowClick.bind(this);

    this.dataGridRef = React.createRef();
  }

  selectRequests({ selectedRowsData }) {
    this.setState({ selectedRequests: selectedRowsData });
  }

  exportSelectedRequests(selectionOnly) {
    this.dataGridRef.current.instance.exportToExcel(selectionOnly);
  }

  searchByText(e) {
    const text = e.target.value;
    this.dataGridRef.current.instance.searchByText(text);
  }

  triggerColumnChooser() {
    this.dataGridRef.current.instance.showColumnChooser();
  }

  onRowClick(e) {
    const focusedRequest = e !== -1 ? e.data.id : e;
    const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    this.setState({ focusedRequest, focusedRowIndex });
  }

  render() {
    const {
      //selectedRequests,
      focusedRowIndex,
      focusedRequest
    } = this.state;

    const {
      requestsData,
      classes,
      //getRequests
    } = this.props;

    const requestActions = [
      {
        label: "Удалить выбранные",
        disabled: true
      },
      {
        label: "Экспортировать выбранные",
        onClick: () => this.exportSelectedRequests(true)
      },
      {
        label: "Экспортировать все",
        onClick: () => this.exportSelectedRequests(false)
      },
      {
        label: "Выбор видимых столбцов",
        onClick: this.triggerColumnChooser
      }
    ];

    console.log(requestsData);

    return (
      <div className={classes.root}>
        <Box>
          <div className={classes.controls}>
            <div>
              <SquareButton>
                <CachedIcon fontSize="small"/>
              </SquareButton>
              <SearchField width={400} />
            </div>
            <div>
              <OrgRequestActions actions={requestActions} />
            </div>
          </div>
          <div>
            <DataGrid
              elementAttr={{
                id: "gridContainer"
              }}
              ref={this.dataGridRef}
              wordWrapEnabled={true}
              dataSource={requestsData.requestsList}
              onSelectionChanged={this.selectRequests}
              focusedRowEnabled
              errorRowEnabled={false}
              onRowClick={this.onRowClick}
              focusedRowIndex={focusedRowIndex}
              showBorders
            >
              <Selection
                mode="multiple"
                showCheckBoxesMode="onClick"
                showBorders={true}
                width={120}
              />
              {columns.map(column => (
                <Column key={column.dataField} {...column} />
              ))}
              <FilterRow visible={true} />
              <Scrolling mode="virtual" />
              <LoadPanel enabled />
            </DataGrid>
          </div>
        </Box>
        <OutsideClickHandler onOutsideClick={() => this.onRowClick(-1)}>
          <OrgRequestDrawer
            handleDrawerClose={() => this.onRowClick(-1)}
            reqId={focusedRequest}
            open={focusedRowIndex !== -1}
          />
        </OutsideClickHandler>
      </div>
    );
  }
}

export default withStyles(styles)(OrgRequestTable);
